import {
    IFeriado,
    ITiposFeriados,
} from "../../../Interfaces/Geral/Feriado/FeriadoInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarTiposFeriadosService() {
    return Service(
        Axios.get<Array<ITiposFeriados>>(`/home/feriado/listartiposferiado`)
    );
}

export async function CadastrarFeriadoService(requestBody: IFeriado) {
    return Service(Axios.post(`/home/feriado/cadastrarferiado`, requestBody));
}

export async function AtualizarFeriadoService(
    id: number,
    requestBody: IFeriado
) {
    return Service(
        Axios.put(`/home/feriado/atualizarferiado/${id}`, requestBody)
    );
}

export async function ListarFeriadosService() {
    return Service(Axios.get<Array<IFeriado>>(`/home/feriado/listarferiados`));
}

export async function DeletarFeriadoService(id: number) {
    return Service(Axios.delete(`/home/feriado/deletarferiado/${id}`));
}
